export default __webpack_public_path__ + "29e2069f516d42ce688db800e9d3ac32.png";